import ChevronLeft from "@/assets/ChevronLeft.svg";
import ChevronRight from "@/assets/ChevronRight.svg";
import { DynamicHtml, DynamicText, FeaturedEmployerCard } from "@/ui";
import clsx from "classnames";
import { chunk } from "lodash/array";
import { Carousel, Col, Container, Row } from "react-bootstrap";
import classes from "./styles.module.scss";

export const FeaturedEmployers = ({ className, title, description, items }) => {
  return (
    <div className={clsx(className, classes.featured)}>
      <Container>
        <Row>
          <Col xs={12} md={6}>
            <h2>{title}</h2>
            <p>{description}</p>
          </Col>
          <Col xs={12} md={6}>
            <Carousel
              className={classes.featured__carousel}
              controls={true}
              prevIcon={<ChevronLeft width="14" height="25" />}
              nextIcon={<ChevronRight width="14" height="25" />}
            >
              {chunk(items, 6).map((items, k) => (
                <Carousel.Item key={k}>
                  <Row>
                    {items.map(({ title, img, href }, k) => (
                      <Col key={k} xs={6} md={4}>
                        <FeaturedEmployerCard className="mb-4" title={title} img={img} href={href} />
                      </Col>
                    ))}
                  </Row>
                </Carousel.Item>
              ))}
            </Carousel>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default FeaturedEmployers;
